import { useState, useEffect, useRef } from 'react';

export default function useSimClock(startHour = 9, startMinute = 0) {
  const [totalMinutes, setTotalMinutes] = useState(startHour * 60 + startMinute);
  const [cycle, setCycle] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setTotalMinutes(prev => {
        const next = prev + 1;
        // 6:00 PM = 18 * 60 = 1080 → loop back to 9:00 AM
        if (next >= 18 * 60) {
          setCycle(c => c + 1);
          return startHour * 60 + startMinute;
        }
        return next;
      });
    }, 1000);
    return () => clearInterval(interval);
  }, [startHour, startMinute]);

  const hour = Math.floor(totalMinutes / 60);
  const minute = totalMinutes % 60;
  const isPM = hour >= 12;
  const displayHour = hour > 12 ? hour - 12 : (hour === 0 ? 12 : hour);
  const timeStr = `${displayHour}:${String(minute).padStart(2, '0')} ${isPM ? 'PM' : 'AM'}`;

  return { totalMinutes, hour, minute, timeStr, dateStr: 'Mon, Jan 27', cycle };
}

export function parseTimeToMinutes(timeStr) {
  const match = timeStr.match(/(\d+):(\d+)\s*(AM|PM)/i);
  if (!match) return 0;
  let h = parseInt(match[1]);
  const m = parseInt(match[2]);
  const period = match[3].toUpperCase();
  if (period === 'PM' && h !== 12) h += 12;
  if (period === 'AM' && h === 12) h = 0;
  return h * 60 + m;
}

export function parseDurationToMinutes(durStr) {
  const match = durStr.match(/(\d+)\s*min/i);
  return match ? parseInt(match[1]) : 30;
}
